<template>
    <div style="margin-top:30px">
        <el-form ref="form" label-width="100px" :model="form">
                       
                <el-row>
                    <el-col :span="24">
                        <div class="grid-content bg-purple">
                            <el-form-item label="姓名" style="margin-right:15px">
                                <el-input v-model="form.boardName" :disabled="true"/>
                            </el-form-item>
                        </div>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <div class="grid-content bg-purple">
                            <el-form-item label="电话" style="margin-right:15px">
                                <el-input v-model="form.boardPhone" :disabled="true"/>
                            </el-form-item>
                        </div>
                    </el-col>
                </el-row>
               
                <el-row>
                    <el-col :span="24">
                        <div class="grid-content bg-purple">
                            <el-form-item label="留言内容" style="margin-right:15px">
                                <el-input v-model="form.boardContent" :disabled="true"/>
                            </el-form-item>
                        </div>
                    </el-col>
                </el-row>
              
                
        </el-form>
    </div>
</template>
<script>
    import request from '@/utils/request'
    export default {
        name: 'messageBoardDetail',
        data() {
            return {
                emptyForm:{},
                form: {
                    code: '',
                    userCode: '',
                    branchCode: '',
                    boardName: '',
                    boardPhone: '',
                    boardEmail: '',
                    boardContent: '',
                    boardCompany: '',
                    readNumber: '',
                }
            }
        },
        created() {
            //保存空表单对象
            this.emptyForm =JSON.parse(JSON.stringify(this.form))
        },
        methods: {
            // 获取页面信息
            getInfo(code) {
                //查询到数据之前先展示空表单
                this.form=JSON.parse(JSON.stringify(this.emptyForm))
                request({ url: `/ntocc-basic-api/messageBoard/${code}`, method: 'get' }).then(response => {
                    this.form = response.data
                })
            }
        }
    }
</script>
<style lang="scss" scoped>
    .dialog-footer {
        margin-top: 50px;
    }
</style>
